import { authApi } from "shared/api/authApi";

export const resetPasswordRequest = ({ password, resetToken }) => {
  return authApi.resetPassword(
    { password },
    {
      headers: {
        Authorization: `Bearer ${resetToken}`,
      },
    },
  );
};
